<template>
  <div class="js-system-user app-container">
    <app-search>
      <div slot="content">
        <el-row type="flex" :gutter="10" justify="start" align="middle">
          <el-col :span="7">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('system.user.searchLabelWidth1')">
              <el-form-item :label="$t('system.user.searchName') + '：'">
                <el-input v-model="listQuery.name" :placeholder="$t('system.user.searchName')" clearable />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <!-- 清空按钮 -->
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 授权按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-add="handleAdd"
      @click-update="handleUpdate"
      @click-delete="handleDelete"
      @click-updatepwd="handleUpdatePwd"
      @click-export="hanleExport"
      @click-filter="showfilter=true"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      ref="table"
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      style="width: 100%"

      @row-click="rowClick"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <!-- 如果需要特性化显示可使用v-if，v-else-if，v-else-->
          <div v-if="item.prop==='isDisabled' ">
            <span
              :class="scope.row[item.prop]===1?'errors':'defaults'"
              :style="{
                borderBottomWidth: '1px',
                cursor:'pointer'
              }"
            >
              {{ scope.row[item.prop] | switchText(item.prop) }}
            </span>
          </div>
          <div v-else>
            {{ scope.row[item.prop] ||  (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 新增修改dialog -->
    <add-update-dialog
      :visibles.sync="addUpdateVisible"
      :is-edit="isEdit"
      :mobile='mobile'
      :data="isEdit?tableRow:{}"
      @add-complete="addComplete"
      @update-complete="updateComplete"
    />
  </div>
</template>

<script>
// 混入
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
// request
import { getUser, deleteUser, resetStatus, exportUser, resetPassword ,getMobile} from '@/api/system/user'

// 组件
import AddUpdateDialog from './components/addUpdateDialog'

// 辅助函数
export default {
  name: 'user',
  components: {
    AddUpdateDialog
  },
  filters: {
    // 后期处理v-html无法编译已定义组件
    switchText(val, type) {
      if (type === 'isDisabled') {
        return val === 1 ? vm.$t('system.user.ban') : vm.$t('system.user.enable')
      } else if (type === 'sex') {
        return val === 1 ? vm.$t('system.user.male') : val === 2 ? vm.$t('system.user.female') : ''
      } else {
        return val
      }
    }
  },
  mixins: [pagingMixin, otherHeight, tableStyle, getPageButton],
  data() {
    return {
      mobile: '',
      listQuery: { name: '' },
      allStationList: [],
      showfilter: false,
      tableList: [
        { value: this.$t('system.user.loginAccount'), prop: 'loginName', position: 'center', width: this.$t('system.user.tableWidth.loginAccount'), checked: true },
        { value: this.$t('system.user.userName'), prop: 'realName', position: 'center', width: this.$t('system.user.tableWidth.userName'),  checked: true },
        { value: this.$t('system.user.userRole'), prop: 'roleName', position: 'center', width: this.$t('system.user.tableWidth.accountStatus'),  checked: true },
        // { value: this.$t('system.user.gender'), prop: 'sex', position: 'center', width: this.$t('system.user.tableWidth.userName'),  checked: true },
        { value: this.$t('public.mobile'), prop: 'mobile', position: 'center', width: this.$t('system.user.tableWidth.phoneNumber'), sortable: 'custom',  checked: true },
        { value: this.$t('system.user.accountStatus'), prop: 'isDisabled', position: 'center', width: this.$t('system.user.tableWidth.accountStatus'),  checked: true },
        { value: this.$t('system.user.openingTime'), prop: 'createdOn', position: 'center', width: this.$t('system.user.tableWidth.openingTime'),  checked: true },
        { value: this.$t('public.note'), prop: 'remark', position: 'center', width: 120, checked: true }
      ],
      // authouizeList: [],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      addUpdateVisible: false, // 新增修改dialog
      isEdit: false, // false: 新增, true:编辑
      tableRow: {} // 缓存点击tableRow数据
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  mounted() {
    
  },
  methods: {
    // 导出
    hanleExport() {
      const { name } = this.listQuery
      exportUser({ name })
    },
    // 加载数据
    listLoad() {
      this.listLoading = true
      getUser(this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
          let orderSort = 'loginName,realName,roleName,isDisabled,createdOn'
          this.setOrderField(orderSort, this.tableList)
          this.tableRow = {}
        }
        this.listLoading = false
      }).catch(()=>{
         this.listLoading = false
      })
    },
    // 点击列
    rowClick(row, column) {
      const label = column.label
      this.list.some((item, index) => {
        if (item.userId === row.userId) {
          row.$index = index
        }
      })
      this.tableRow = row
      

      const postData = {
      }
      if (label === this.$t('system.user.accountStatus')) {
        postData.isDisabled = row.isDisabled
        postData.statusvalue = row.isDisabled
        postData.statustype = 0
        this._restStatus(postData)
      }
      
    },
    _restStatus(postData) {
      let confimText; let url = ''
      if (postData.isDisabled == 1) {
        confimText = this.$t('system.user.enable')
        url = `/user/enable/${this.tableRow.userId}`
      } else {
        confimText = this.$t('system.user.ban')
        url = `/user/disable/${this.tableRow.userId}`
      }

      this.$confirm(`${confimText}${this.tableRow.loginName}?`, this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      }).then(() => {
        resetStatus(url).then(({ data }) => {
          if (data.code === 0) {
            this.tableRow.isDisabled = this.tableRow.isDisabled === 0 ? 1 : 0
          }
        })
      })
    },

    // 判断tablerow行是否选择
    tableRowIsSlect() {
      const { $index } = this.tableRow
      if ($index === undefined) {
        return false
      } else {
        return true
      }
    },
    // 新增
    handleAdd() {
      this.isEdit = false
      this.addUpdateVisible = true
    },
    // 新增完成
    addComplete() {
      this.listLoad()
      this.$message.success({
        message: this.$t('public.createSuccess'),
        duration: 2 * 1000
      })
    },
    // 编辑
    handleUpdate() {
      if (this.tableRowIsSlect()) {
        
        getMobile(this.tableRow.userId).then(res=>{
        if(res.data.code==0){
        this.tableRow.realMobile=res.data.data
        this.isEdit = true
        this.addUpdateVisible = true
        }
      }) 
      } else {
        this.$alert(this.$t('public.updateTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
          .then(() => {})
          .catch(() => {})
      }
    },
    // 编辑成功
    updateComplete() {
      this.listLoad()
      this.$message.success({
        message: this.$t('public.updateSuccess'),
        duration: 2 * 1000
      })
    },
    // 删除
    handleDelete() {
      if (this.tableRow.$index === undefined) {
        this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      })
        .then(() => {
          deleteUser(this.tableRow.userId).then(({ data }) => {
            if (data.code === 0) {
              if (this.list && this.list.length === 1) {
                this.listQuery.pageNum =
                  this.listQuery.pageNum > 1
                    ? this.listQuery.pageNum - 1
                    : this.listQuery.pageNum
                this.listLoad()
              } else {
                this.list.splice(this.tableRow.$index, 1)
                this.tableRow = {}
              }
              this.total--
              this.$message.success({
                message: this.$t('public.deleteSuccess'),
                duration: 2 * 1000
              })
            }
          })
        })
        .catch(() => {})
    },
    handleUpdatePwd() {
      if (this.tableRowIsSlect()) {
        this.$confirm(this.$t('system.user.msg1'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define'),
          cancelButtonText: this.$t('public.cancel'),
          type: 'warning'
        })
          .then(() => {
            resetPassword(this.tableRow.userId).then(({ data }) => {
              if (data.code === 0) {
                this.$message.success({
                  message: this.$t('system.user.msg2'),
                  duration: 2 * 1000
                })
              }
            })
          })
          .catch(() => {})
      } else {
        this.$alert(this.$t('system.user.tips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
          .then(() => {})
          .catch(() => {})
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.defaults{
  border-bottom: 1px solid #409EFF
}
.errors{
   border-bottom: 1px solid #ff0000
}
</style>
